import { ViewState } from 'modules/host-payout-methods/context/PayoutFormContext';

export default function (state: ViewState, action): ViewState {
  switch (action.type) {
    case 'CLEAR_CURRENT_PAYOUT':
      return {
        currentView: 'METHOD',
        previousViews: [],
      };
    case 'ON_NEXT':
      switch (state.currentView) {
        case 'METHOD':
          return {
            currentView: 'DETAILS',
            previousViews: [...state.previousViews, state.currentView],
          };
        case 'DETAILS':
          return {
            currentView: 'CONFIRM',
            previousViews: [...state.previousViews, state.currentView],
          };
        default:
          return state;
      }
    case 'ON_BACK':
      if (state.previousViews.length >= 1) {
        const newCurrentView =
          state.previousViews[state.previousViews.length - 1];
        return {
          currentView: newCurrentView,
          previousViews: state.previousViews.slice(
            0,
            state.previousViews.length - 1,
          ),
        };
      }
      return state;
  }
  return state;
}
